import holidays from "./holidays.component";
import holidaysUrls from "./holidays.urls";
import HolidaysTransforms from "./holidays.transforms";

const holidaysModule = angular
  .module("app.components.holidays", [])
  .component("holidaysPage", holidays)
  .service("HolidaysTransforms", HolidaysTransforms)
  .config(holidaysUrls);

export default holidaysModule;



// WEBPACK FOOTER //
// ./src/pages/holidays/holidays.module.js